import { LoadingOutlined } from '@ant-design/icons';
import { ProductDoc } from '@gooduncles/gu-app-schema';
import { unionBy } from 'lodash';
import { FC } from 'react';

import useProrductsForMainTag from 'src/hooks/useProrductsForMainTag';
import useProrductsForTag from 'src/hooks/useProrductsForTag';

import EmptyList from 'src/components/atoms/EmptyList/EmptyList';
import ProductHorizontalItem from 'src/components/organisms/ProductItem/ProductHorizontalItem/ProductHorizontalItem';

import classes from './TagProductList.module.scss';

type TagProps = {
  tag: string;
  unhiddenProducts: ProductDoc['_id'][];
  // 상품 상세 페이지에서 현재 보고있는 상품의 id, 목록에서 중복되어 나오지 않게 하기 위함
  curProductId?: ProductDoc['_id'];
};

const TagProductList: FC<TagProps> = ({ tag, unhiddenProducts, curProductId }) => {
  const { productsForMainTag, productsForMainTagLoading, productsForMainTagError } = useProrductsForMainTag(
    tag,
    unhiddenProducts
  );
  const { productsForTag, productsForTagLoading, productsForTagError } = useProrductsForTag(tag, unhiddenProducts);
  const products = unionBy([...productsForMainTag, ...productsForTag], 'productId').filter(
    (product) => product.productId !== curProductId
  );

  if (productsForMainTagError || productsForTagError) {
    return (
      <div style={{ height: '100%', overflow: 'hidden' }}>
        <EmptyList isError />
      </div>
    );
  }

  return (
    <div className={`${classes.tagProductListContainer} ${products.length > 0 ? 'addPadding' : ''}`}>
      {productsForMainTagLoading || productsForTagLoading ? (
        <div className={classes.loadingBox}>
          <LoadingOutlined />
        </div>
      ) : products.length > 0 ? (
        products.map((product) => <ProductHorizontalItem key={'tag' + product.productId} product={product} />)
      ) : (
        <EmptyList />
      )}
    </div>
  );
};

export default TagProductList;
